// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2y86B","range":"MonthRangeSwitch_range__1VBuP","disabled":"MonthRangeSwitch_disabled__SxJwf"};